export enum MarketType {
    Free = 'Free',
    Guaranteed = 'Guaranteed',
    Fui = 'Fui',
    Safeguard = 'Safeguard',
    TutelaGraduale = 'TutelaGraduale',
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/marketType.ts